import React from 'react';
import { ScrollLink } from "react-scroll";
import {Link} from "react-router-dom";
import '../../../styles/tutorial archive/Themes.css';

// Images
const Images = {
    ThemeDevMenu: require("../../../Assets/Tutorials/Themes Tutorial/Page 5 - Upload Your Theme/OpenThemeDev.png"),
    Landing: require("../../../Assets/Tutorials/Themes Tutorial/Page 5 - Upload Your Theme/Landing.png"),
    Dashboard: require("../../../Assets/Tutorials/Themes Tutorial/Page 5 - Upload Your Theme/Dashboard.png"),
    UploadMenu: require("../../../Assets/Tutorials/Themes Tutorial/Page 5 - Upload Your Theme/UploadMenu.png"),
    UploadTheme: require("../../../Assets/Tutorials/Themes Tutorial/Page 5 - Upload Your Theme/UploadThemeReal.png"),

};

const otherAssets = {
    square: require("../../../Assets/Website Pack/Square.png"),
}

export default function configurableSprites() {
    return (
        <div className="about-frame">

                <div id="about">
                    <p>Uploading Your Theme</p>
                </div>
                <div className="simple-center-align">
            <span className="normal-text">
            If you're here, that means you're done making a theme; and I congratulate you! It's no easy task.
</span>
                    <div className="about-leftalign">
                        <br></br>
                        <br></br>

                        {/* Sections to jump to */}
                        <div id="upload-your-theme" className="sectionFormatting">

                            <div id="theme-developer-dashboard" className="sectionFormatting">
                                <h2>Theme Developer Dashboard</h2>
                                <p>This is a menu accessed when you're in the "Themes" menu...</p>
                                <img
                                    src={Images.ThemeDevMenu}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Image opening Themes.png!"
                                />
                                <p>
                                    and in the bottom menu bar, click "Develop Theme". </p>
                                <p>Your theme should show in the list of WIP
                                    Themes,
                                    if you've actually put it in the right folder... (check the introduction of the
                                    tutorial).
                                </p>
                                <img
                                    src={Images.Landing}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Image opening Themes.png!"
                                />
                                <p>If you click it, it'll take you to a new menu which shows all the information of your
                                    theme, and the
                                    menu bar shows you some useful tools.</p>
                                <img
                                    src={Images.Dashboard}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Image opening Themes.png!"
                                />
                                <p>
                                    "Upload to Steam" - Takes you to the menu that lets you upload your Theme to the
                                    Marketplace (Steam
                                    Workshop), and thankfully it is a One-Click thing.
                                    <br></br>"Reveal in Finder" - Opens the Theme's directory on your machine.
                                    <br></br>"Use (Preview)" - Equips your theme for previewing, but requires a Scene
                                    Reload to take
                                    full effect, as with any other Theme.
                                </p>
                                <p>
                                    <br></br><br></br>
                                    You'll want to click "Upload to Steam", and then you'll get to the Marketplace -
                                    where you'll upload
                                    your Theme.
                                </p>
                                <img
                                    src={Images.UploadMenu}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Image opening Themes.png!"
                                />
                                <p>
                                    and after clicking the second upload button, navigate to the directory in which your
                                    Theme is, and
                                    it should upload fine!
                                </p>
                                <img
                                    src={Images.UploadTheme}
                                    style={{height: "293px", width: "520px"}}
                                    alt="Image opening Themes.png!"
                                />
                                <p>
                                    <br></br>Now it will take you to the Steam Workshop page of your Theme, since it's
                                    privacy settings are on Private
                                    by default - this is to allow a player time to make sure the item page looks exactly
                                    how they want.
                                </p>

                            </div>

                            <div id="next-section" className="sectionFormatting">
                                <h2>Exit Tutorial: Wishlist Poly Beats Right Now!</h2>
                                <p>
                                    At the time of writing, it is not out yet. This tutorial is for Playtesters that
                                    were allowed to make themes, but if you wanna be the first to play Poly Beats on
                                    release day and make your theme, you better wishlist, now!
                                </p>

                                <iframe src="https://store.steampowered.com/widget/2734590/" frameBorder="0"
                                        width="720" height="200"></iframe>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
            );
            }